<template>
  <div class="gw_select">
    <GwMenu
      :trigger
      :isInside
      :hasStretch
      :placement
      :ignoreDataGwmenu="true"
    >
      <template #opener="{ value }">
        <div class="gw_select_title">
          <div
            v-if="title"
            class="text-medium weight_500 clr-grey truncate"
          >
            {{ title }}
          </div>
          <div
            v-if="hasArrow"
            class="mdi mdi-menu-down clr-greys text-semi-large transition_03 icon_btn"
            :class="{ rotated_180_before: value }"
            :data-tst="`${tstPrefix}_opener`"
            style="transition: 0.22s"
          />
        </div>
      </template>
      <template #default="{ methods }">
        <slot name="select_menu">
          <!-- TODO GwBtns better support for disabled -->
          <!-- :disabled="disabledOptions" -->
          <GwBtns
            class="gw_menu"
            :class="gwBtnsClass"
            style="padding: 0.5rem; max-height: clamp(1px, 44rem, 100vh)"
            data-gwmenu="noclose"
            :options="options"
            :values="selectedOptions"
            :idKey="idKey"
            @click.stop="
              (_e, item) => {
                $emit('click:option', item)
                if (closeOnContentClick) {
                  methods.toggleOpen(false)
                }
              }
            "
          >
            <template #before>
              <slot name="menu_before"></slot>
            </template>
            <template #default="{ item }">
              <slot
                :name="`${slotPrefix}menu_item`"
                :item="item"
              >
                {{ item }}
              </slot>
            </template>
          </GwBtns>
        </slot>
      </template>
    </GwMenu>
    <slot name="select_selected_options">
      <GwBtns
        v-if="selectedOptions"
        class="gwbtns_horizontal_white"
        :options="selectedOptions"
        style="padding: 0; --gwbtns-wrap: wrap"
        @click.stop="
          (_e, item) => {
            $emit('click:selectedoption', item)
          }
        "
      >
        <template #default="{ item }">
          <slot
            :name="`${slotPrefix}selected_item`"
            :item="item"
          >
            {{ item }}
            <div class="icon_btn mdi mdi-close ml-1"></div>
          </slot>
        </template>
      </GwBtns>
    </slot>
  </div>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import GwBtns from '@/components/lib/GwBtns'

export default {
  name: 'GwSelect',
  components: {
    GwMenu,
    GwBtns,
  },
  props: {
    gwBtnsClass: { type: String, default: 'gwbtns_vertical_white' },
    hasArrow: { type: Boolean, default: true },
    hasStretch: { type: Boolean, default: true },
    idKey: { type: String, default: 'id' },
    isInside: { type: Boolean, default: false },
    options: { type: Array, default: () => [] },
    placement: { type: String, default: 'bottom-start' },
    selectedOptions: { type: Array, default: () => [] },
    slotPrefix: { type: String, default: '' },
    title: { type: String, default: 'title' },
    trigger: { type: String, default: 'click' },
    tstPrefix: { type: String, default: 'gwselect' },
    closeOnContentClick: Boolean,
  },
  emits: ['click:option', 'click:selectedoption'],
  data() {
    return {}
  },

  watch: {},
}
</script>

<style lang="scss" scoped>
.gw_select {
  display: flex;
  border: solid 1px var(--clr-black-2);
  border-radius: 4px;
  padding: 0.125rem 0.25rem 0.125rem 0;
  min-height: 2rem;
  max-width: 100%;
  gap: 0.125rem;
  &_title {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 1.5rem;
    padding: 0 0 0 0.5rem;
    // margin: 0 0.25rem auto 0;
  }
  // &_selected_options {
  //   display: flex;
  //   max-width: 100%;
  // }
}
</style>
